const ProductDetailComments = {
  "options": {
    "data": {},
    "customization": {},
    "widgets": {
      "Menu_TitleSettings": {
        "type": "Menu",
        "order": 100,
        "renderOptions": {
          "controlKey": "titleSettings"
        },
        "options": {
          "text": {
            "type": "Text",
            "order": 1
          },
          "textSize": {
            "type": "RangePx",
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            },
            "order": 2
          },
          "textColor": {
            "type": "HexColor",
            "order": 3
          },
          "textAlignment": {
            "type": "LeftCenterRight",
            "order": 4
          },
          "textStyle": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["normal", "italic"]
            },
            "order": 5
          },
          "textWeight": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
            },
            "order": 6
          }
        }
      },
      "Menu_RaitingSettings": {
        "type": "Menu",
        "order": 200,
        "renderOptions": {
          "controlKey": "raitingSettings"
        },
        "options": {
          "raitingNumberTextColor": {
            "type": "HexColor",
            "order": 1
          },
          "raitingNumberTextSize": {
            "type": "RangePx",
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            },
            "order": 2
          },
          "raitingNumberTextStyle": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["normal", "italic"]
            },
            "order": 2
          },
          "raitingNumberTextWeight": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
            },
            "order": 3
          },
          "isShowStar": {
            "type": "Radio",
            "order": 4,
            "data": {
              "direction": "row",
              "radioOptions": ["show", "notShow"]
            }
          },
          "starSize": {
            "type": "RangePx",
            "data": {
              "max": 36,
              "min": 6,
              "step": 1
            },
            "order": 5
          },
          "starColor": {
            "type": "HexColor",
            "order": 6
          },
          "totalRaitingTextColor": {
            "type": "HexColor",
            "order": 7
          },
          "totalRaitingTextSize": {
            "type": "RangePx",
            "data": {
              "max": 36,
              "min": 6,
              "step": 1
            },
            "order": 7
          },

          "totalRaitingTextStyle": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["normal", "italic"]
            },
            "order": 8
          },
          "totalRaitingTextWeight": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
            },
            "order": 9
          },
          "horizontalLineTextColor": {
            "type": "HexColor",
            "order": 10
          },
          "horizontalLineTextSize": {
            "type": "RangePx",
            "data": {
              "max": 36,
              "min": 6,
              "step": 1
            },
            "order": 10
          },
          "horizontalLineTextStyle": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["normal", "italic"]
            },
            "order": 11
          },
          "horizontalLineTextWeight": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
            },
            "order": 12
          },
          "horizontalLineColor": {
            "type": "HexColor",
            "order": 13
          },
          "horizontalLineBackgroundColor": {
            "type": "HexColor",
            "order": 14
          }
        }
      },
      "Menu_CommentSettings": {
        "type": "Menu",
        "order": 300,
        "renderOptions": {
          "controlKey": "commentSettings"
        },
        "options": {
          "widget.Tabs_1": {
            "type": "Tabs",
            "order": 1,
            "options": {
              "borderRadius": {
                "data": {
                  "max": 30,
                  "min": 0,
                  "step": 1,
                  "svgType": "border"
                },
                "type": "FourPx"
              }
            }
          },
          "commentTextColor": {
            "type": "HexColor",
            "order": 1
          },
          "commentTextSize": {
            "type": "RangePx",
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            },
            "order": 2
          },
          "commentTextAlignment": {
            "type": "LeftCenterRight",
            "order": 2
          },
          "commentTextStyle": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["normal", "italic"]
            },
            "order": 3
          },
          "commentTextWeight": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
            },
            "order": 4
          },
          "isShowCommentStar": {
            "type": "Radio",
            "order": 5,
            "data": {
              "direction": "row",
              "radioOptions": ["show", "notShow"]
            }
          },
          "commentStarSize": {
            "type": "RangePx",
            "data": {
              "max": 36,
              "min": 6,
              "step": 1
            },
            "order": 6
          },
          "commentStarColor": {
            "type": "HexColor",
            "order": 7
          },
          "commenterAndDateTextColor": {
            "type": "HexColor",
            "order": 8
          },
          "commenterAndDateTextAlignment": {
            "type": "LeftCenterRight",
            "order": 9
          },
          "commenterAndDateTextStyle": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["normal", "italic"]
            },
            "order": 10
          },
          "commenterAndDateTextWeight": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
            },
            "order": 11
          }
        }
      },
      "Menu_ButtonSettings": {
        "type": "Menu",
        "order": 400,
        "renderOptions": {
          "controlKey": "buttonSettings"
        },
        "options": {
          "buttonTextColor": {
            "type": "HexColor",
            "order": 1
          },
          "buttonTextSize": {
            "type": "RangePx",
            "data": {
              "max": 30,
              "min": 0,
              "step": 1
            },
            "order": 2
          },
          "buttonBackgroundColor": {
            "type": "HexColor",
            "order": 2
          },
          "buttonTextStyle": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["normal", "italic"]
            },
            "order": 3
          },
          "buttonTextWeight": {
            "type": "SelectBox",
            "data": {
              "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
            },
            "order": 4
          }
        }
      }
    }
  },
  "variants": [
    {
      "id": "Comments_1",
      "name": "Comments_1",
      "type": "ProductDetailComments",
      "data": {},
      "customization": {
        "text": "Yorumlar ve Değerlendirmeler",
        "textSize": "14px",
        "textColor": "#000000",
        "textStyle": "normal",
        "textAlignment": "left",
        "textWeight": "500",
        "raitingNumberTextColor": "#000000",
        "raitingNumberTextSize": "32px",
        "raitingNumberTextStyle": "normal",
        "raitingNumberTextWeight": "500",
        "isShowStar": "show",
        "starSize": "28px",
        "starColor": "#000000",
        "totalRaitingTextColor": "#666666",
        "totalRaitingTextSize": "12px",
        "totalRaitingTextStyle": "normal",
        "totalRaitingTextWeight": "400",
        "horizontalLineTextColor": "#000000",
        "horizontalLineTextSize": "12px",
        "horizontalLineTextStyle": "normal",
        "horizontalLineTextWeight": "500",
        "horizontalLineColor": "#000000",
        "horizontalLineBackgroundColor": "#eeeeee",
        "borderRadius": "5px 5px 5px 5px",
        "commentTextColor": "#000000",
        "commentTextSize": "14px",
        "commentTextAlignment": "left",
        "commentTextStyle": "normal",
        "commentTextWeight": "500",
        "isShowCommentStar": "show",
        "commentStarSize": "14px",
        "commentStarColor": "#000000",
        "commenterAndDateTextColor": "#707173",
        "commenterAndDateTextStyle": "normal",
        "commenterAndDateTextWeight": "400",
        "buttonTextColor": "#000000",
        "buttonTextSize": "12px",
        "buttonBackgroundColor": "#F3F4F6",
        "buttonTextStyle": "normal",
        "buttonTextWeight": "400"
      },
      "variantData": {
        "isEditable": false,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/commentPlaceholder.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    }
  ]
}

 export default ProductDetailComments